import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/node_modules/.pnpm/next-intl@4.8.3_@swc+helpers@0.5.18_next@16.1.6_@opentelemetry+api@1.9.0_react-dom@19.2_c91d551486f1d032c5a80f31a39c1505/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/opt/buildhome/repo/node_modules/.pnpm/sonner@2.0.7_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/sonner/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/opt/buildhome/repo/src/app/[locale]/providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuroraTextRuntime"] */ "/opt/buildhome/repo/src/components/magicui/text/aurora-text-runtime.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ScopedIntlClientProvider"] */ "/opt/buildhome/repo/src/components/providers/scoped-intl-client-provider.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/styles/marketing-shell.css");
